import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Planning');

export const ROTATIONUSE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.RotationUse.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
  FieldBuilder
    .text('code', 'Entity.RotationUse.Code')
    .required()
    .minLength(2)
    .maxLength(10)
    .build(),
];

export const ROTATIONUSE_CONFIG = {
  entityName: 'RotationUse',
  localizationKey: 'Planning::Entity.RotationUse',
  fields: ROTATIONUSE_FIELDS,
  permission: 'PlanningOperation.RotationUses',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.OperationPlanning + MENU_NAME_SUFFIX,
};
